var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.66797H2.66668C1.9303 2.66797 1.33334 3.26492 1.33334 4.0013V4.66797C1.33334 5.40435 1.9303 6.0013 2.66668 6.0013H13.3333C14.0697 6.0013 14.6667 5.40435 14.6667 4.66797V4.0013C14.6667 3.26492 14.0697 2.66797 13.3333 2.66797Z",
    stroke: "#CBD5E1",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 6V12C2.66666 12.3536 2.80713 12.6928 3.05718 12.9428C3.30723 13.1929 3.64637 13.3333 3.99999 13.3333H12C12.3536 13.3333 12.6927 13.1929 12.9428 12.9428C13.1928 12.6928 13.3333 12.3536 13.3333 12V6",
    stroke: "#CBD5E1",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 8.66797H9.33332",
    stroke: "#CBD5E1",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.fa91601f6036777b48015e9521a50d85.svg";
export { ForwardRef as ReactComponent };